<script setup>
import CFContentPlaceholders from '@/shared/components/CFContentPlaceholders.vue';
import CFContentPlaceholdersBox from '@/shared/components/CFContentPlaceholdersBox.vue';
import CFInvoicesErrorState from '#modules/invoices/components/CFInvoicesErrorState.vue';
import CFPage from '@/shared/components/CFPage.vue';
import { useInvoices } from '#modules/invoices/queries/useInvoices.js';

const { isPending, isError } = useInvoices();
</script>

<template>
    <CFPage>
        <template v-if="!isPending && !isError">
            <RouterView />
        </template>

        <CFContentPlaceholders v-else-if="!isError">
            <CFContentPlaceholdersBox class="h-20" />
        </CFContentPlaceholders>

        <CFInvoicesErrorState v-else />
    </CFPage>
</template>
